import { useTranslation } from "react-i18next";

const IMG = "/assets/img/how-it-works";

const tutors = [
    { key: "tutor_1", img: `${IMG}/tutor-1.jpg`, rating: "4.9" },
    { key: "tutor_2", img: `${IMG}/tutor-2.jpg`, rating: "5.0" },
    { key: "tutor_3", img: `${IMG}/tutor-3.jpg`, rating: "4.8" },
];

export default function HowItWorks() {
    const { t } = useTranslation();

    return (
        <section className="how-it-works">
            <div className="container">
                <h2 className="how-it-works-title">{t("howItWorks.title")}</h2>
                <div className="row g-4">
                    <div className="col-lg-4">
                        <article className="hiw-card">
                            <span className="hiw-step hiw-step--1">1</span>
                            <h3>{t("howItWorks.step_1_title")}</h3>
                            <p>{t("howItWorks.step_1_desc")}</p>
                            <div className="hiw-media hiw-tutors" aria-hidden="true">
                                {tutors.map((tutor) => (
                                    <div className="hiw-tutor" key={tutor.key}>
                                        <img src={tutor.img} alt="" loading="lazy" />
                                        <div className="hiw-tutor-info">
                                            <div className="hiw-tutor-head">
                                                <strong>{t(`howItWorks.${tutor.key}_name`)}</strong>
                                                <span className="hiw-tutor-rating">
                                                    <i className="fa-solid fa-star" /> {tutor.rating}
                                                </span>
                                            </div>
                                            <div className="hiw-tutor-line">
                                                <i className="fa-light fa-graduation-cap" />
                                                <span>{t(`howItWorks.${tutor.key}_subject`)}</span>
                                            </div>
                                            <div className="hiw-tutor-line">
                                                <i className="fa-light fa-language" />
                                                <span>{t(`howItWorks.${tutor.key}_languages`)}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </article>
                    </div>

                    <div className="col-lg-4">
                        <article className="hiw-card">
                            <span className="hiw-step hiw-step--2">2</span>
                            <h3>{t("howItWorks.step_2_title")}</h3>
                            <p>{t("howItWorks.step_2_desc")}</p>
                            <div className="hiw-media hiw-lesson">
                                <img className="hiw-lesson-main" src={`${IMG}/lesson-tutor.jpg`} alt={t("howItWorks.lesson_tutor_alt")} loading="lazy" />
                                <img className="hiw-lesson-inset" src={`${IMG}/lesson-learner.jpg`} alt={t("howItWorks.lesson_learner_alt")} loading="lazy" />
                            </div>
                        </article>
                    </div>

                    <div className="col-lg-4">
                        <article className="hiw-card hiw-card--padded">
                            <span className="hiw-step hiw-step--3">3</span>
                            <h3>{t("howItWorks.step_3_title")}</h3>
                            <p>{t("howItWorks.step_3_desc")}</p>
                            <div className="hiw-media hiw-progress">
                                <img src={`${IMG}/progress-3.jpg`} alt="" aria-hidden="true" loading="lazy" />
                                <img src={`${IMG}/progress-2.jpg`} alt="" aria-hidden="true" loading="lazy" />
                                <img src={`${IMG}/progress-1.jpg`} alt={t("howItWorks.progress_alt")} loading="lazy" />
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    );
}
